import styles from "./CreateTourInfo.module.css";
import TourInfo from './../tour-info/TourInfo';
import { useAppStore } from "../../hooks/store/useAppStore";
import { createTourInfoSelector } from "../../hooks/store/getters";
import { setTourInfoSelector } from "../../hooks/store/setters";
import { setTourErrorInfoSelector } from "../../hooks/store/setters";
import { useValidateForm } from "../../hooks/UseValidateForm";

const CreateTourInfo = () => {

    const tourInfo = useAppStore(createTourInfoSelector);
    const setTourInfo = useAppStore(setTourInfoSelector);
    const setTourErrorInfo = useAppStore(setTourErrorInfoSelector);
    const validateTour = useValidateForm();

    const tourInfoInputChangeHandler = async ({ target: { name, value } }) => {
        setTourInfo({ [name]: value });
        validateTour.validateTourInfo({name,value});
    };
    
    const handlerMarkerUpdate = (position, zoom) => {
        setTourInfo({ ...position, zoom });
        setTourErrorInfo({ latitude: "" });
        setTourErrorInfo({ longitude: "" });
        
    }

    const handleTourPosterUpload = ({ url="", file=null }) => {
        setTourInfo({ 
            tourPoster: { url, file }
        })
        console.log('value',url);
        validateTour.validateTourposter({key:"url",value:url});  
    }
    
    return (
        <div className={styles.createTourInfo}>
            <TourInfo 
                tourInfo={tourInfo} 
                tourInfoInputChangeHandler={tourInfoInputChangeHandler} 
                handleMarkerUpdate={handlerMarkerUpdate}
                handleTourPosterUpload={handleTourPosterUpload}
            />
        </div>
    );
};

export default CreateTourInfo;